/**
 * Christmas Packs PDP accordion
 *
 * Behaviour:
 * - Looks for one or more `.template_6_block__cbwrapper` containers.
 * - Inside each wrapper it expects multiple `.template_6_block__cb` “card” elements.
 * - Cards 1–2 stay visible; cards 3+ are moved into a collapsible panel
 *   controlled by a “Christmas Packs” header block.
 *
 * Shopify notes:
 * - Safe to include globally; it will only run on pages that render the wrapper.
 * - Re-runs automatically on theme editor section load (`shopify:section:load`).
 * - Exposes `window.initChristmasPacksAccordion(root?)` if you need to call it manually.
 */

(function () {
  function initChristmasPacksAccordion(root) {
    const context = root instanceof HTMLElement ? root : document;
    const wrappers = Array.from(
      context.querySelectorAll('.template_6_block__cbwrapper')
    );

    if (!wrappers.length) {
      // Silently no-op if not found – this is expected on non-PDP pages
      return;
    }

    wrappers.forEach((wrapper) => {
      const cards = Array.from(
        wrapper.querySelectorAll('.template_6_block__cb')
      );

      if (cards.length < 3) {
        // Not enough cards to split; bail for this wrapper only
        return;
      }

      // Cleanup if re-running on the same wrapper
      wrapper.classList.remove('pdp-card-split-open');
      wrapper.querySelector('.pdp-card-split-block')?.remove();
      wrapper.querySelector('.pdp-card-split-panel-wrapper')?.remove();

      // Insert accordion header before 3rd card
      const header = document.createElement('div');
      header.className = 'pdp-card-split-block';
      header.setAttribute('role', 'button');
      header.setAttribute('tabindex', '0');
      header.setAttribute('aria-expanded', 'false');

      header.innerHTML = `
        <div class="pdp-card-split-inner">
          <div>
            <h3 class="pdp-card-split-heading">Christmas Packs</h3>
            <p class="pdp-card-split-text">Tap to reveal Gift Packs & Savings</p>
          </div>
          <span class="pdp-card-split-icon">+</span>
        </div>
      `;

      const thirdCard = cards[2];
      wrapper.insertBefore(header, thirdCard);

      // Create wrapper to animate hidden cards
      const panelWrapper = document.createElement('div');
      panelWrapper.className = 'pdp-card-split-panel-wrapper';
      wrapper.insertBefore(panelWrapper, thirdCard);

      // Move cards 3+ into wrapper
      cards.forEach((card, index) => {
        if (index >= 2) panelWrapper.appendChild(card);
      });

      // Toggle logic
      const toggle = () => {
        const open = wrapper.classList.toggle('pdp-card-split-open');
        header.classList.toggle('is-open', open);
        header.setAttribute('aria-expanded', open ? 'true' : 'false');
      };

      header.addEventListener('click', toggle);
      header.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          toggle();
        }
      });
    });
  }

  // Expose for manual use if needed (e.g. after app blocks re-render)
  window.initChristmasPacksAccordion = initChristmasPacksAccordion;

  // Run on initial page load
  const runOnLoad = () => initChristmasPacksAccordion();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runOnLoad);
  } else {
    runOnLoad();
  }

  // Re-run when sections are dynamically loaded in the theme editor
  document.addEventListener('shopify:section:load', (event) => {
    initChristmasPacksAccordion(event.target);
  });
})();
